import produce from 'immer'
import { cloneDeep } from 'lodash'
import { getType } from 'typesafe-actions'
import * as actions from './actions'
import { State, Action } from './types'
import { initEvent, initMeta } from 'Store/common/common.reducer'
import parseErrorMessage from 'helpers/parseErrorMessage'
import { convertMetaData } from 'Store/common/common.function'

const initialState: State = {
  list: {
    data: [],
    meta: cloneDeep(initMeta),
  },
  listEvent: cloneDeep(initEvent),
  actionEvent: cloneDeep(initEvent),
  detail: undefined,
  detailEvent: cloneDeep(initEvent),
  masterProductsList: {
    data: [],
    meta: cloneDeep(initMeta),
  },
  requestProducts: {
    data: [],
    meta: cloneDeep(initMeta),
  },
  allProductList: {
    data: [],
    meta: cloneDeep(initMeta),
  },
  bomDetail: [],
  bomDetailEvent: cloneDeep(initEvent),
  checkingProductFile: {
    data: {
      dup: [],
      ok: [],
    },
  },
  checkingProductFileEvent: cloneDeep(initEvent),
  lastProductsImport: [],
  importProductEvent: cloneDeep(initEvent),
  logRequestProducts: {
    data: [],
    meta: cloneDeep(initMeta),
  },
  requestProductDetail: undefined,
  requestProductDetailEvent: cloneDeep(initEvent),
}

export default function(state: State = initialState, action: Action) {
  return produce(state, draft => {
    let response
    switch (action.type) {
      case getType(actions.getListAction.request):
        draft.listEvent = cloneDeep(initEvent)
        draft.listEvent.IsLoading = true
        draft.list = {
          data: [],
          meta: cloneDeep(initMeta),
        }
        return draft
      case getType(actions.getListAction.success):
        response = action.payload
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitSuccess = true
        draft.list.data = response.data
        if (response.meta) {
          draft.list.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getListAction.failure):
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getDetailAction.request):
        draft.detailEvent = cloneDeep(initEvent)
        draft.detailEvent.IsLoading = true
        draft.detail = undefined
        return draft
      case getType(actions.getDetailAction.success):
        response = action.payload
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitSuccess = true
        draft.detail = response.data
        return draft
      case getType(actions.getDetailAction.failure):
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getBomDetailAction.request):
        draft.bomDetailEvent = cloneDeep(initEvent)
        draft.bomDetailEvent.IsLoading = true
        draft.bomDetail = []
        return draft
      case getType(actions.getBomDetailAction.success):
        response = action.payload
        draft.bomDetailEvent.IsLoading = false
        draft.bomDetailEvent.SubmitSuccess = true
        draft.bomDetail = response.data
        return draft
      case getType(actions.getBomDetailAction.failure):
        draft.bomDetailEvent.IsLoading = false
        draft.bomDetailEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.updateAction.request):
      case getType(actions.createAction.request):
      case getType(actions.deleteAction.request):
      case getType(actions.importProductAction.request):
      case getType(actions.updateRequestStatusAction.request):
      case getType(actions.updateProductStatusAction.request):
      case getType(actions.updateProductPriceAction.request):
      case getType(actions.updateProductBomAction.request):
        draft.actionEvent = cloneDeep(initEvent)
        draft.actionEvent.IsLoading = true
        return draft
      case getType(actions.createProductFromFileAction.request):
        draft.importProductEvent = cloneDeep({ ...initEvent, IsLoading: true })
        return draft
      case getType(actions.deleteAction.success):
      case getType(actions.importProductAction.success):
      case getType(actions.updateProductStatusAction.success):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = undefined
        draft.actionEvent.SubmitSuccess = true
        draft.actionEvent.MessageSuccess = 'บันทึกข้อมูลสำเร็จ'
        return draft
      case getType(actions.createAction.success):
      case getType(actions.updateAction.success):
        response = action.payload
        if (response?.status?.code === 200) {
          draft.actionEvent.IsLoading = false
          draft.actionEvent.SubmitError = undefined
          draft.actionEvent.SubmitSuccess = true
          draft.actionEvent.MessageSuccess = 'บันทึกข้อมูลสำเร็จ'
        } else {
          draft.actionEvent.IsLoading = false
          draft.actionEvent.SubmitError = response?.message
        }
        return draft
      case getType(actions.updateRequestStatusAction.success):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = undefined
        draft.actionEvent.SubmitSuccess = true
        draft.actionEvent.MessageSuccess = 'ทำรายการสำเร็จ'
        return draft
      case getType(actions.updateProductPriceAction.success):
      case getType(actions.updateProductBomAction.success):
        response = action.payload
        if (response?.status?.code === 200) {
          draft.actionEvent.IsLoading = false
          draft.actionEvent.SubmitError = undefined
          draft.actionEvent.SubmitSuccess = true
          draft.actionEvent.MessageSuccess = 'บันทึกข้อมูลสำเร็จ'
        } else {
          draft.actionEvent.IsLoading = false
          draft.actionEvent.SubmitError = response?.message
        }
        return draft
      case getType(actions.createProductFromFileAction.success):
        response = action.payload
        if (response?.status?.code === 200) {
          draft.importProductEvent.SubmitError = undefined
          draft.importProductEvent.SubmitSuccess = true
          draft.importProductEvent.MessageSuccess = 'นำเข้าสินค้าสำเร็จ'
          draft.lastProductsImport = response.data || []
        } else {
          draft.importProductEvent.IsLoading = true
          draft.importProductEvent.SubmitError = response?.message
        }
        return draft
      case getType(actions.createAction.failure):
      case getType(actions.updateAction.failure):
      case getType(actions.deleteAction.failure):
      case getType(actions.importProductAction.failure):
      case getType(actions.updateRequestStatusAction.failure):
      case getType(actions.updateProductStatusAction.failure):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.createProductFromFileAction.failure):
        draft.importProductEvent.IsLoading = true
        draft.importProductEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.updateProductPriceAction.failure):
      case getType(actions.updateProductBomAction.failure):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = action.payload.message || 'เกิดข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้'
        return draft
      case getType(actions.getMasterProductAction.request):
        draft.detailEvent = cloneDeep(initEvent)
        draft.detailEvent.IsLoading = true
        draft.masterProductsList = {
          data: [],
          meta: cloneDeep(initMeta),
        }
        return draft
      case getType(actions.getMasterProductAction.success):
        response = action.payload
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitSuccess = true
        draft.masterProductsList.data = response.data
        if (response.meta) {
          draft.masterProductsList.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getMasterProductAction.failure):
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getRequestProductsAction.request):
        draft.listEvent = cloneDeep(initEvent)
        draft.listEvent.IsLoading = true
        draft.requestProducts = {
          data: [],
          meta: cloneDeep(initMeta),
        }
        return draft
      case getType(actions.getRequestProductsAction.success):
        response = action.payload
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitSuccess = true
        draft.requestProducts.data = response.data
        if (response.meta) {
          draft.requestProducts.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getRequestProductsAction.failure):
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.getLogRequestProductsAction.request):
        draft.listEvent = cloneDeep(initEvent)
        draft.listEvent.IsLoading = true
        draft.logRequestProducts = {
          data: [],
          meta: cloneDeep(initMeta),
        }
        return draft
      case getType(actions.getLogRequestProductsAction.success):
        response = action.payload
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitSuccess = true
        draft.logRequestProducts.data = response.data
        if (response.meta) {
          draft.logRequestProducts.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getLogRequestProductsAction.failure):
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getAllProductListAction.request):
        draft.listEvent = cloneDeep(initEvent)
        draft.listEvent.IsLoading = true
        draft.allProductList = {
          data: [],
          meta: cloneDeep(initMeta),
        }
        return draft
      case getType(actions.getAllProductListAction.success):
        response = action.payload
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitSuccess = true
        draft.allProductList.data = response.data
        if (response.meta) {
          draft.allProductList.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getAllProductListAction.failure):
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.checkingProductFromFileAction.request):
        draft.checkingProductFileEvent = cloneDeep(initEvent)
        draft.checkingProductFileEvent.IsLoading = true
        draft.checkingProductFile.data = {
          dup: [],
          ok: [],
        }
        return draft
      case getType(actions.checkingProductFromFileAction.success):
        response = action.payload
        if (response?.status?.code === 200) {
          draft.checkingProductFileEvent.IsLoading = false
          draft.checkingProductFileEvent.SubmitSuccess = true
          draft.checkingProductFile.data = response.data
        } else {
          draft.checkingProductFileEvent.IsLoading = false
          draft.checkingProductFileEvent.SubmitError = response?.message
        }
        return draft
      case getType(actions.checkingProductFromFileAction.failure):
        draft.checkingProductFileEvent.IsLoading = false
        draft.checkingProductFileEvent.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.getApproveProductDetailAction.request):
        draft.requestProductDetailEvent = cloneDeep(initEvent)
        draft.requestProductDetailEvent.IsLoading = true
        draft.requestProductDetail = undefined
        return draft
      case getType(actions.getApproveProductDetailAction.success):
        response = action.payload
        draft.requestProductDetailEvent.IsLoading = false
        draft.requestProductDetailEvent.SubmitSuccess = true
        draft.requestProductDetail = response.data
        return draft
      case getType(actions.getApproveProductDetailAction.failure):
        draft.requestProductDetailEvent.IsLoading = false
        draft.requestProductDetailEvent.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.clearEventAction):
        draft.listEvent = cloneDeep(initEvent)
        draft.actionEvent = cloneDeep(initEvent)
        draft.detailEvent = cloneDeep(initEvent)
        draft.bomDetailEvent = cloneDeep(initEvent)
        draft.checkingProductFileEvent = cloneDeep(initEvent)
        draft.importProductEvent = cloneDeep(initEvent)
        return draft
      case getType(actions.resetLastImportAction):
        draft.lastProductsImport = []
        return draft
      case getType(actions.clearChunkEventAction):
        draft.importProductEvent = {
          IsLoading: true,
          SubmitError: '',
          SubmitSuccess: false,
          SubmitType: '',
          MessageSuccess: '',
        }
        return draft

      default:
        return state
    }
  })
}
